module.exports = __webpack_public_path__ + "static/media/pro.782adc2b.png";